import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";

const services = [
  {
    title: "Donasi",
    icon: "/images/logo/logo1.png",
    path: "/donasi",
  },
  {
    title: "Berita",
    icon: "/images/logo/logo2.png",
    path: "/berita",
  },
  {
    title: "Relawan",
    icon: "/images/logo/logo3.png",
    path: "/relawan",
  },
  {
    title: "Daftar",
    icon: "/images/logo/logo4.png",
    path: "https://patunganindonesia.online/inspirator/register",
  },
];

const HeroSection = () => {
  const [typedText, setTypedText] = useState("");
  const [charIndex, setCharIndex] = useState(0);
  const fullText = "Bantu Wujudkan Harapan Bersama.";

  useEffect(() => {
    let t: ReturnType<typeof setTimeout>;

    if (charIndex <= fullText.length) {
      t = setTimeout(() => {
        setTypedText(fullText.slice(0, charIndex));
        setCharIndex((p) => p + 1);
      }, 80);
    } else {
      t = setTimeout(() => setCharIndex(0), 2000);
    }

    return () => clearTimeout(t);
  }, [charIndex]);
  return (
    <section className="relative overflow-hidden bg-[#f7f5fa] -mt-8">
      {/* BACKGROUND GEDUNG */}
      <img src="/images/gedung.png" className="absolute bottom-0 left-0 w-full h-[700px] pointer-events-none" alt="" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 py-12 sm:py-16 md:py-20">
        {/* TITLE */}
        <div className="text-center max-w-3xl mx-auto">
          <h1 className="font-semibold text-4xl md:text-6xl">
            <span className="text-primary2">Patungan</span> <span className="text-black2">Indonesia</span>
          </h1>

          <p className="mt-3 text-gray-600 text-sm sm:text-base md:text-lg">Platform donasi terpercaya. Mari berbagi kebaikan untuk masa depan yang lebih baik.</p>

          <p className="text-black2 text-base md:text-3xl font-semibold h-[32px] mt-2 font-bilbo">
            {typedText}
            <span className="animate-pulse">|</span>
          </p>
        </div>

        {/* CARDS */}
        <div className="mt-8 sm:mt-10 md:mt-12">
          <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-4 gap-3 sm:gap-4 md:gap-6">
            {services.map((item) => (
              <NavLink
                key={item.title}
                to={item.path}
                className="
        bg-white
        rounded-2xl
        p-4 sm:p-5 md:p-6
        shadow-md
        hover:shadow-xl
        hover:-translate-y-1
        transition-all
        text-center
        block
      ">
                <div className="flex justify-center mb-3">
                  <img src={item.icon} alt={item.title} className="w-14 h-14 sm:w-14 sm:h-14 md:w-20 md:h-20 object-contain" />
                </div>

                <h3 className="text-xs sm:text-sm md:text-base font-medium text-gray-700 leading-tight">{item.title}</h3>
              </NavLink>
            ))}
          </div>
        </div>

        {/* BUTTON */}
        <div className="flex justify-center mt-8 sm:mt-10 md:mt-12">
          <NavLink
            to="/donasi"
            className="
    bg-secondary
    hover:bg-green-800
    text-white
    px-6 sm:px-8 md:px-10
    py-3
    rounded-full
    text-sm sm:text-base md:text-lg
    shadow-[0_0_20px_rgba(132,204,22,0.7)]
    hover:shadow-[0_0_30px_rgba(132,204,22,0.9)]
    transition-all
    duration-300
  ">
            Patungan Sekarang
          </NavLink>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
